import { core, dateUtil } from '@/core'
import Basic from '@basic'
import {
  YearTable,
  DateTable,
  MonthTable,
  Input,
  DatePicker,
  Button,
} from '@bag'

const kickInputMode = {
  TH: {
    showIcon: false,
    timeHead: false,
    mode: 'H',
    clearable: false,
    size: 'mini',
  },
  TM: {
    showIcon: false,
    timeHead: false,
    mode: 'HM',
    clearable: false,
    size: 'mini',
  },
  TS: {
    showIcon: false,
    timeHead: false,
    mode: 'HMS',
    clearable: false,
    size: 'mini',
  },
}

const util = {
  pullTimeHeader(opt, tar) {
    if (opt.timeHead) {
      const date = this.pullDateInput(opt, tar)
      const time = this.pullTimeInput(opt, tar)
      return [date, time]
    }
    tar.members.timePanel.hide()
    return null
  },
  pullFooter(opt, tar) {
    const btnNow = this.pullBtnNow(opt, tar)
    const btnSure = this.pullBtnSure(opt, tar)
    return [btnNow, btnSure]
  },
  pullBtnNow(opt, tar) {
    const { footer } = tar.members
    const option = {
      type: 'text',
      textContent: '当前时间',
    }
    const btn = new Button(option)
    btn.unit.addClass('picker-panel__link-btn').appendTo(footer)
    return btn
  },
  pullBtnSure(opt, tar) {
    const { footer } = tar.members
    const option = {
      textContent: '确认',
      plain: true,
    }
    const btn = new Button(option)
    btn.unit.addClass('picker-panel__link-btn').appendTo(footer)
    return btn
  },
  pullDateInput(opt, tar) {
    const { dateInput } = tar.members
    const option = {
      type: 'text',
      readonly: true,
      clearable: false,
      placeholder: '选择日期',
      size: 'mini',
    }
    const input = new Input(Object.assign({}, opt, option))
    dateInput.append(input.unit)
    return input
  },
  pullTimeInput(opt, tar) {
    const { timeInput } = tar.members
    const option = this.kickInput(opt.mode)
    const input = new DatePicker(Object.assign({}, opt, option))
    timeInput.append(input.unit)
    return input
  },
  pullYearTable(opt, tar) {
    const { content } = tar.members
    const table = new YearTable({})
    content.append(table.unit)
    return table
  },
  pullMonthTable(opt, tar) {
    const { content } = tar.members
    const table = new MonthTable({})
    content.append(table.unit)
    return table
  },
  pullDateTable(opt, tar) {
    const { content } = tar.members
    const table = new DateTable({})
    content.append(table.unit)
    return table
  },
  kickInput(mode) {
    const opt = kickInputMode[mode] || {}
    return Object.assign({}, opt)
  },
  titleChange(opt, tar) {
    const { yearLabel, monthLabel } = tar.members
    const level = tar.level
    if (level === 0) {
      const starYear = tar.table[0].startYear()
      yearLabel.text(`${starYear}年 - ${starYear + 9}年`)
    } else if (level === 1) {
      yearLabel.text(`${tar.year}年`)
    } else if (level === 2) {
      yearLabel.text(`${tar.year}年`)
      monthLabel.text(`${tar.month + 1}月`)
    }
  },
  template: {
    panel(opt, tar) {
      return $(`
      <div class="picker-panel date-picker lt-popper has-sidebar" style="position: absolute; top: 375px; left: 482px; z-index: 2003;">
        <div id="wrapper" class="picker-panel__body-wrapper">
          <div id="sidebar" class="picker-panel__sidebar">
            <button type="button" class="picker-panel__shortcut">今天</button>
          </div>
          <div id="body" class="picker-panel__body">
            <div id="timePanel" class="date-picker__time-header">
              <span id="dateInput" class="date-picker__editor-wrap"></span>
              <span id="timeInput" class="date-picker__editor-wrap"></span>
            </div>
            <div class="date-picker__header">
              <button id="prevYear" type="button" class="picker-panel__icon-btn date-picker__prev-btn fa fa-angle-double-left"></button>
              <button id="prevMonth" type="button" class="picker-panel__icon-btn date-picker__prev-btn fa fa-angle-left"></button>
              <span id="yearLabel" class="date-picker__header-label">1999</span>
              <span id="monthLabel" class="date-picker__header-label">3月</span>
              <button id="nextYear" type="button" class="picker-panel__icon-btn date-picker__next-btn fa fa-angle-double-right"></button>
              <button id="nextMonth" type="button" class="picker-panel__icon-btn date-picker__next-btn fa fa-angle-right"></button>
            </div>
            <div id="content" class="picker-panel__content"></div>
          </div>
        </div>
        <div id="footer" class="picker-panel__footer">
        </div>
      </div>`)
    },
  },
  updater: {
    // 基本功能: 是否显示
    show(value, opt, tar, node) {
      if (value) {
        tar.unit.show()
      } else {
        tar.unit.hide()
      }
      tar.shown()
    },
    // 基本功能: 显示层级
    level(value, opt, tar, node) {
      tar.table.map(item => {
        if (item) {
          item.show = false
        }
      })
      tar.table[value] && (tar.table[value].show = true)
      const { yearLabel, monthLabel, prevMonth, nextMonth } = tar.members
      if (value === 0) {
        monthLabel.hide()
        prevMonth.hide()
        nextMonth.hide()
      } else if (value === 1) {
        monthLabel.hide()
        prevMonth.hide()
        nextMonth.hide()
      } else if (value === 2) {
        monthLabel.show()
        prevMonth.show()
        nextMonth.show()
      }
      util.titleChange(opt, tar)
    },

    // 基本功能: date
    date(value, opt, tar, node) {
      tar.table.map(item => {
        if (item) {
          item.date = value
        }
        util.titleChange(opt, tar)
      })
      if (tar.timeHeader) {
        tar.timeHeader[0].value = dateUtil.formateDate(value)
        tar.timeHeader[1].value = dateUtil.formateTime1(value)
      }
    },
    // 扩展功能: 左侧快捷键
    shortcut(value, opt, tar, node) {
      const { sidebar, body } = tar.members
      if (value) {
        tar.unit.addClass('has-sidebar')
        body.before(sidebar)
      } else {
        tar.unit.removeClass('has-sidebar')
        sidebar.detach()
      }
    },
    // 扩展功能: 底部按钮
    footer(value, opt, tar, node) {
      const { footer, wrapper } = tar.members
      if (value) {
        wrapper.after(footer)
      } else {
        footer.detach()
      }
    },
  },
}

export default class DatePanel extends Basic {
  constructor(opt) {
    super(opt)
    this.defaults = {
      weeks: ['日', '一', '二', '三', '四', '五', '六'], // 基本功能: 周表
      date: new Date(), // 基本功能: 设置时间
      show: false, // 基本功能: 是否显示
      lvl: 2, // 基本功能: 设定的层级
      level: 2, // 基本功能: 当前显示的层级

      max: null, // 基本功能: 最大时间
      min: null, // 基本功能: 最小时间

      shortcut: false, // 扩展功能: 左侧快捷键
      footer: false, // 扩展功能: 底部按钮
    }
    this.events = {
      click: 'onClick',
      shown: 'onShown',
      sure: 'onSure',
      cancel: 'onCancel',
    }
    core.proxyApi(this) // 核心属性处理
    core.proxyEvent(this) // 核心事件处理
    this.settings = Object.assign({}, this.defaults, opt)
    this.init()
  }

  init() {
    const opt = this.settings
    const { mode } = opt
    const template = util.template.panel(opt, this)
    const members = {}
    core.compileSymbol(template[0], members)
    this.members = members
    this.unit = template
    this.table = []
    this.timeHeader = util.pullTimeHeader(opt, this)
    this.footerBtn = util.pullFooter(opt, this)
    if (this.timeHeader) {
      this.dateIn = this.timeHeader[0]
      this.timeIn = this.timeHeader[1]
    }
    this.table[0] = util.pullYearTable(opt, this)
    if (!['Y'].includes(mode)) this.table[1] = util.pullMonthTable(opt, this)
    if (!['Y', 'M'].includes(mode)) {
      this.table[2] = util.pullDateTable(opt, this)
    }
    core.update(util.updater, opt, this)
    this.bindInput()
  }

  bindInput() {
    const {
      yearLabel,
      monthLabel,
      prevYear,
      prevMonth,
      nextYear,
      nextMonth,
    } = this.members
    yearLabel.click($.proxy(this.handleJumpLevel, this, 0))
    monthLabel.click($.proxy(this.handleJumpLevel, this, 1))
    prevYear.click($.proxy(this.handleJumpPage, this, -10))
    prevMonth.click($.proxy(this.handleJumpPage, this, -1))
    nextYear.click($.proxy(this.handleJumpPage, this, 10))
    nextMonth.click($.proxy(this.handleJumpPage, this, 1))
    this.table[0].click($.proxy(this.handleYearClick, this))
    if (this.table[1]) this.table[1].click($.proxy(this.handleMonthClick, this))
    if (this.table[2]) this.table[2].click($.proxy(this.handleDateClick, this))
    this.footerBtn[0].click($.proxy(this.handleNowClick, this))
    this.footerBtn[1].click($.proxy(this.sure, this))
    if (this.timeHeader) {
      this.timeHeader[1].change($.proxy(this.handleTimeClick, this))
    }
  }

  handleTimeClick() {
    const time = this.timeHeader[1].date
    const [hh, mm, ss] = [time.getHours(), time.getMinutes(), time.getSeconds()]
    const date = this.date
    date.setHours(hh)
    date.setMinutes(mm)
    date.setSeconds(ss)
    this.date = date
    this.click()
  }

  handleNowClick(tar, value) {
    this.date = new Date()
    this.click()
  }

  handleDateClick(tar, value) {
    this.date = dateUtil.changeDate(this.date, value)
    this.click()
  }

  handleMonthClick(tar, value) {
    this.date = dateUtil.changeMonth(this.date, value)
    this.click()
  }

  handleYearClick(tar, value) {
    this.date = dateUtil.changeYear(this.date, value)
    this.click()
  }

  handleJumpPage(value) {
    const level = this.level
    const date = this.date
    if (level === 0) {
      const ny = date.getFullYear() + value
      this.date = dateUtil.changeYear(date, ny)
    } else if (level === 1) {
      const ny = date.getFullYear() + (value * 1) / 10
      this.date = dateUtil.changeYear(date, ny)
    } else if (level === 2) {
      const ny = date.getFullYear() + value
      this.date = dateUtil.changeYear(date, ny)
    }
    util.titleChange(this.settings, this)
  }

  handleJumpLevel(lvl) {
    this.level = lvl
  }

  onClick() {
    if (this.level === this.lvl) {
      if (!this.footer) {
        this.key = false
      }
    } else {
      this.level = this.level + 1
      return false
    }
  }

  onSure() {
    this.key = false
  }

  onCancel() {
    this.key = false
  }

  onShown() {
    this.key = true
  }

  get year() {
    return this.date.getFullYear()
  }

  get month() {
    return this.date.getMonth()
  }
}
